/**
 * スクロールバーを除いたビューポート幅をCSS変数に設定する
 */
const setViewportWidthVariable = () => {
  const setWidth = () => {
    const viewportWidth = document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
      '--js-width__viewport',
      `${viewportWidth}px`,
    );
  };

  // 初期設定
  setWidth();

  // ページ読み込み完了後に再計算（レイアウトが安定してから）
  window.addEventListener('load', () => {
    setTimeout(setWidth, 50);
  });

  // ウィンドウリサイズ時に再計算
  window.addEventListener('resize', setWidth);
};

export { setViewportWidthVariable };
